import { IonButton, IonRow } from '@ionic/react';
import React, { useCallback } from 'react';
import { DqText } from 'src/components/dq-text';

import { useIntl } from 'react-intl';
import { FirmwareMessages } from 'src/intl/FirmwareMessages';
import './FirmwareGrid.scss';
import { FirmwareFile } from './types';

interface FirmwareFileUploadFormProps {
  /**
   * Triggers the request to close the modal and save the state object.
   */
  onSave: (uploadedFile: FirmwareFile) => void;
}

export const FirmwareFileUploadForm: React.FC<FirmwareFileUploadFormProps> = ({ onSave }) => {
  const intl = useIntl();
  const fileField = React.useRef<HTMLInputElement>(null);

  const handleFileChange = useCallback(
    (ev: any) => {
      const uploadedFile = ev.currentTarget.files[0];
      onSave(uploadedFile);
    },
    [onSave],
  );

  return (
    <>
      <IonRow>
        <DqText variant="body">{intl.formatMessage(FirmwareMessages.selectAFile)}</DqText>
      </IonRow>
      <div>
        <IonButton
          onClick={() => document?.getElementById('upload-firmware-input')?.click()}
          className="upload-firmware-input-button"
          fill="clear"
        >
          <IonRow className="ion-justify-content-center">
            <DqText color="secondary">{intl.formatMessage(FirmwareMessages.selectAFile)}</DqText>
          </IonRow>
          <input
            onChange={handleFileChange}
            ref={fileField}
            type="file"
            accept=".bin"
            className="upload-firmware-input"
            id="upload-firmware-input"
          />
        </IonButton>
      </div>
      <IonRow>
        <DqText variant="body-strong">{intl.formatMessage(FirmwareMessages.onlyBinFiles)}</DqText>
      </IonRow>
    </>
  );
};

export default FirmwareFileUploadForm;
